import React, { useState } from 'react';
import Icon from './Icon';

const GlobalPlayerManagement = ({ players, onAddPlayer, onDeletePlayer, onBack }) => {
  const [name, setName] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);

  const handleAdd = () => {
    if (!name.trim()) return;
    onAddPlayer(name.trim());
    setName('');
  };

  const handleDelete = (playerId) => {
    onDeletePlayer(playerId);
    setShowDeleteConfirm(null);
  };

  return (
    <div className="min-h-screen p-4">
      <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
        <Icon d="M15 19l-7-7 7-7" />
        Retour
      </button>

      <h1 className="text-2xl font-bold mb-4">Gestion des Joueurs ({players.length})</h1>

      <div className="mb-6 flex gap-2">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleAdd()}
          placeholder="Nom du joueur"
          className="flex-1 bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:border-red-500"
        />
        <button
          onClick={handleAdd}
          className="bg-red-600 text-white px-6 rounded-lg font-semibold active:bg-red-700"
        >
          <Icon d="M12 4v16m8-8H4" />
        </button>
      </div>

      <div className="space-y-2">
        {players.map(player => (
          <div key={player.id} className="bg-gray-800 p-4 rounded-lg flex items-center justify-between">
            <div>
              <div className="font-semibold">{player.name}</div>
              <div className="text-sm text-gray-400">
                Créé le {new Date(player.createdAt).toLocaleDateString('fr-FR')}
              </div>
            </div>
            <button
              onClick={() => setShowDeleteConfirm(player.id)}
              className="text-red-500 font-semibold px-4 py-2 rounded-lg border border-red-500 hover:bg-red-500 hover:text-white transition"
            >
              Supprimer
            </button>
          </div>
        ))}
      </div>

      {/* Modal de confirmation de suppression */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-800 rounded-lg p-6 max-w-sm w-full">
            <h3 className="text-lg font-bold mb-4">Confirmer la suppression</h3>
            <p className="text-gray-300 mb-6">
              Êtes-vous sûr de vouloir supprimer ce joueur ? Cette action est irréversible.
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowDeleteConfirm(null)}
                className="flex-1 bg-gray-700 text-white py-3 rounded-lg font-semibold"
              >
                Annuler
              </button>
              <button
                onClick={() => handleDelete(showDeleteConfirm)}
                className="flex-1 bg-red-600 text-white py-3 rounded-lg font-semibold"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalPlayerManagement;